module.exports = __webpack_public_path__ + "img/b5a8632.svg";